module.exports = __webpack_public_path__ + "static/media/tree_page8.84064973.png";